<template>
  <DataNotFound/>
</template>

<script>
	import DataNotFound from '@/components/DataNotFound';

  export default {
		name: 'Patent',
		components: {
			DataNotFound,
		},
  }
</script>